import { render } from "./MailSignature.vue?vue&type=template&id=6ce70766&ts=true"
import script from "./MailSignature.vue?vue&type=script&lang=ts"
export * from "./MailSignature.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/thomasplanckaert/Dedalus/GIT/carteconfituur/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__